import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export const initialParentPoint = () => ({
  categoriesList: {
    list: [],
    count: 0,
  },
  parentPointDetail: {},
  customerList: {
    list: [],
    count: 0,
  },
  historyPointList: {
    list: [],
    count: 0,
    point: 0,
    plannedPoint: 0
  },
  pointQRCodePulldown: [],
  historyPointTypeList: {
    list: []
  },
  shopPointList: {
    list: []
  },
  pointStoreList: {
    list: [],
    count: 0
  },
  aggregratePointDetail: {},
  customerPointActivities: [],
  customerPointActivitiesCpm: {},
  pointQRList: {
    list: [],
    count: 0
  },
  pointQrDetail: {},
  sortText: '',
  sortType: '',
  releaseOtpList: {
    list: [],
    count: 0
  },
  allQrTicketList: {
    list: [],
    count: 0
  },
  otpList: {
    list: [],
    count: 0,
    inactiveCount: 0,
    isFinish: false,
  },
});

export default {
  state: initialParentPoint(),
  mutations,
  actions,
  getters,
  namespaced: true
};
